import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import React, { Component, Fragment } from 'react';
import MAP_DATA from '../../js/utils/googleMapData';

const GOOGLE_API_KEY = 'AIzaSyB_n8-ujKPIYXhRUWYk5YKFNNyJ_ezsjb8';

const style = {
  width: '100%',
  height: '100%',
};

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.UNISPORT_FLAGSHIP_MAP_DATA = MAP_DATA[props.language];
  }

  fetchPlaces(mapProps, map) {
    const { google, placeId } = mapProps;
    const service = new google.maps.places.PlacesService(map);
    service.getDetails({
      placeId: placeId
    }, function(place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const marker = new google.maps.Marker({
          map: map,
          position: place.geometry.location,
          name: 'Worlds best football shop!!'
        });
      }
    });
  }
  renderMap(){
    const data = this.UNISPORT_FLAGSHIP_MAP_DATA;
    return(
      <Map
        clickableIcons={true}
        google={this.props.google}
        onReady={this.fetchPlaces}
        style={style}
        zoom={16}
        placeId={data.PLACE_ID}
        initialCenter={{
          lat: data.LAT,
          lng: data.LNG
      }}>
      </Map>
    )
  }
  render(){
    return(
      <Fragment>
        {this.renderMap()}
      </Fragment>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: GOOGLE_API_KEY,
  version: '3.30',
})(MapContainer);
